// import React, { useState, useEffect, useRef } from 'react';

// const AIChatbot = () => {
//   const [userMessage, setUserMessage] = useState('');
//   const [conversation, setConversation] = useState([
//     {
//       sender: 'SSPACE Bot',
//       text: 'Hello! I\'m SSPACE Bot, your AI learning assistant. How can I help you with your studies today?',
//       timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
//     }
//   ]);
//   const [loading, setLoading] = useState(false);
//   const messagesEndRef = useRef(null);

//   // Scroll to the bottom when new messages are added
//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//   }, [conversation]);

//   const handleSend = async () => {
//     if (!userMessage.trim()) return;

//     const timestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    
//     // Add user message
//     setConversation((prev) => [...prev, { 
//       sender: 'You', 
//       text: userMessage,
//       timestamp 
//     }]);
    
//     const currentMessage = userMessage;
//     setUserMessage('');
//     setLoading(true);

//     try {
//       // Replace this with your actual API call
//       // const userId = localStorage.getItem('userId') || 'guest';
//       // const response = await axios.post(
//       //   `${process.env.REACT_APP_API_URL}/api/chatbot`,
//       //   { message: currentMessage, userId: userId }
//       // );
//       // const botReply = response.data.reply;
      
//       // Simulate API call for demo
//       await new Promise(resolve => setTimeout(resolve, 1500));
      
//       const botReplies = [
//         "That's a great question! Let me help you understand this concept better. I can provide detailed explanations and examples to make sure you grasp the material thoroughly.",
//         "I can definitely assist you with that topic. Here's what you need to know... This is a fundamental concept that builds upon previous knowledge.",
//         "Excellent! This is an important area of study. Let me break it down for you step by step so you can understand it completely.",
//         "I'm here to help you succeed in your studies. Here's my detailed response with examples and practice suggestions...",
//         "That's a fascinating topic! Let me provide you with comprehensive information and additional resources for deeper learning."
//       ];
      
//       const botReply = botReplies[Math.floor(Math.random() * botReplies.length)];
//       const botTimestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

//       setConversation((prev) => [...prev, { 
//         sender: 'SSPACE Bot', 
//         text: botReply,
//         timestamp: botTimestamp 
//       }]);
//     } catch (error) {
//       console.error('Error:', error);
//       const errorTimestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//       setConversation((prev) => [...prev, { 
//         sender: 'SSPACE Bot', 
//         text: 'Sorry, something went wrong. Please try again.',
//         timestamp: errorTimestamp 
//       }]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter' && !e.shiftKey) {
//       e.preventDefault();
//       handleSend();
//     }
//   };

//   const TypingIndicator = () => (
//     <div className="typing-indicator">
//       <div className="avatar bot-avatar">
//         <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
//           <path d="M20,9V7c0-1.1-0.9-2-2-2h-3c0-1.66-1.34-3-3-3S9,3.34,9,5H6C4.9,5,4,5.9,4,7v2c-1.1,0-2,0.9-2,2v4 c0,1.1,0.9,2,2,2v2c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-2c1.1,0,2-0.9,2-2v-4C22,9.9,21.1,9,20,9z M7.5,11.5 C7.5,10.67,8.17,10,9,10s1.5,0.67,1.5,1.5S9.83,13,9,13S7.5,12.33,7.5,11.5z M16.5,11.5c0,0.83-0.67,1.5-1.5,1.5 s-1.5-0.67-1.5-1.5S14.17,10,15,10S16.5,10.67,16.5,11.5z M8,15h8v2H8V15z"/>
//         </svg>
//       </div>
//       <div className="typing-bubble">
//         <div className="typing-dots">
//           <div className="dot"></div>
//           <div className="dot"></div>
//           <div className="dot"></div>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="chatbot-container">
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
//         .chatbot-container {
//           min-height: 100vh;
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           position: relative;
//           overflow: hidden;
//           padding: 2rem 1rem;
//           font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
//         }

//         .chatbot-container::before {
//           content: '';
//           position: absolute;
//           top: 15%;
//           left: 8%;
//           width: 60px;
//           height: 60px;
//           border-radius: 50%;
//           background: rgba(255, 255, 255, 0.1);
//           animation: float 3s ease-in-out infinite;
//         }

//         .chatbot-container::after {
//           content: '';
//           position: absolute;
//           top: 60%;
//           right: 15%;
//           width: 80px;
//           height: 80px;
//           border-radius: 50%;
//           background: rgba(255, 255, 255, 0.05);
//           animation: float 4s ease-in-out infinite;
//           animation-delay: 1s;
//         }

//         @keyframes float {
//           0%, 100% { transform: translateY(0px); }
//           50% { transform: translateY(-10px); }
//         }

//         @keyframes messageSlide {
//           from { opacity: 0; transform: translateX(-20px); }
//           to { opacity: 1; transform: translateX(0); }
//         }

//         @keyframes botMessageSlide {
//           from { opacity: 0; transform: translateX(20px); }
//           to { opacity: 1; transform: translateX(0); }
//         }

//         @keyframes typing {
//           0%, 60%, 100% { transform: translateY(0); }
//           30% { transform: translateY(-5px); }
//         }

//         .chat-wrapper {
//           max-width: 800px;
//           margin: 0 auto;
//           height: 100vh;
//           display: flex;
//           flex-direction: column;
//           position: relative;
//           z-index: 1;
//         }

//         .header {
//           text-align: center;
//           margin-bottom: 2rem;
//         }

//         .header-chip {
//           display: inline-flex;
//           align-items: center;
//           gap: 0.5rem;
//           background: rgba(255, 255, 255, 0.15);
//           color: white;
//           padding: 0.5rem 1rem;
//           border-radius: 50px;
//           font-size: 0.9rem;
//           font-weight: 500;
//           margin-bottom: 1rem;
//           backdrop-filter: blur(10px);
//         }

//         .header-chip svg {
//           width: 16px;
//           height: 16px;
//         }

//         .main-title {
//           font-size: clamp(2rem, 5vw, 3rem);
//           font-weight: 900;
//           color: white;
//           margin-bottom: 0.5rem;
//           text-shadow: 0 4px 20px rgba(0,0,0,0.3);
//         }

//         .gradient-text {
//           background: linear-gradient(45deg, #FFD700, #FF6B6B, #4ECDC4);
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//           background-clip: text;
//         }

//         .subtitle {
//           color: rgba(255, 255, 255, 0.9);
//           font-weight: 300;
//           font-size: 1.1rem;
//         }

//         .chat-container {
//           flex: 1;
//           display: flex;
//           flex-direction: column;
//           background: rgba(255, 255, 255, 0.95);
//           backdrop-filter: blur(20px);
//           border-radius: 20px;
//           border: 1px solid rgba(255, 255, 255, 0.2);
//           overflow: hidden;
//           box-shadow: 0 20px 40px rgba(0,0,0,0.1);
//         }

//         .chat-header {
//           padding: 1.5rem 2rem;
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           color: white;
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//         }

//         .chat-header-avatar {
//           width: 48px;
//           height: 48px;
//           border-radius: 50%;
//           background: rgba(255, 255, 255, 0.2);
//           backdrop-filter: blur(10px);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .chat-header-info h3 {
//           margin: 0;
//           font-weight: 600;
//           font-size: 1.2rem;
//         }

//         .chat-header-info p {
//           margin: 0;
//           opacity: 0.8;
//           font-size: 0.9rem;
//         }

//         .messages-area {
//           flex: 1;
//           overflow-y: auto;
//           padding: 1rem 0;
//           background: linear-gradient(to bottom, rgba(248, 250, 252, 0.5), rgba(241, 245, 249, 0.3));
//         }

//         .messages-area::-webkit-scrollbar {
//           width: 6px;
//         }

//         .messages-area::-webkit-scrollbar-track {
//           background: transparent;
//         }

//         .messages-area::-webkit-scrollbar-thumb {
//           background: rgba(148, 163, 184, 0.5);
//           border-radius: 10px;
//         }

//         .message-item {
//           display: flex;
//           align-items: flex-start;
//           margin-bottom: 1.5rem;
//           padding: 0 2rem;
//           animation: messageSlide 0.3s ease-out;
//         }

//         .message-item.user {
//           flex-direction: row-reverse;
//           animation: botMessageSlide 0.3s ease-out;
//         }

//         .avatar {
//           width: 40px;
//           height: 40px;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           flex-shrink: 0;
//         }

//         .bot-avatar {
//           background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
//           box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
//           margin-right: 1rem;
//         }

//         .user-avatar {
//           background: linear-gradient(45deg, #4ECDC4 30%, #44A08D 90%);
//           box-shadow: 0 4px 12px rgba(78, 205, 196, 0.3);
//           margin-left: 1rem;
//         }

//         .message-content {
//           max-width: 75%;
//           display: flex;
//           flex-direction: column;
//         }

//         .user .message-content {
//           align-items: flex-end;
//         }

//         .message-bubble {
//           padding: 1rem 1.5rem;
//           border-radius: 20px;
//           word-wrap: break-word;
//           line-height: 1.5;
//           backdrop-filter: blur(10px);
//           margin-bottom: 0.25rem;
//         }

//         .user-bubble {
//           background: linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%);
//           color: white;
//           box-shadow: 0 8px 20px rgba(254, 107, 139, 0.3);
//           font-weight: 500;
//         }

//         .bot-bubble {
//           background: rgba(255, 255, 255, 0.9);
//           color: #374151;
//           border: 1px solid rgba(209, 213, 219, 0.5);
//           box-shadow: 0 4px 12px rgba(0,0,0,0.05);
//         }

//         .message-timestamp {
//           font-size: 0.75rem;
//           color: rgba(107, 114, 128, 0.7);
//           margin-top: 0.25rem;
//         }

//         .typing-indicator {
//           display: flex;
//           align-items: flex-start;
//           margin-bottom: 1rem;
//           padding: 0 2rem;
//         }

//         .typing-bubble {
//           padding: 1rem 1.5rem;
//           border-radius: 20px;
//           background: rgba(229, 231, 235, 0.8);
//           backdrop-filter: blur(10px);
//           margin-left: 1rem;
//         }

//         .typing-dots {
//           display: flex;
//           gap: 0.25rem;
//         }

//         .dot {
//           width: 8px;
//           height: 8px;
//           border-radius: 50%;
//           background-color: #9ca3af;
//           animation: typing 1.4s ease-in-out infinite;
//         }

//         .dot:nth-child(2) { animation-delay: 0.2s; }
//         .dot:nth-child(3) { animation-delay: 0.4s; }

//         .input-area {
//           padding: 1.5rem 2rem;
//           background: rgba(255, 255, 255, 0.8);
//           backdrop-filter: blur(10px);
//           border-top: 1px solid rgba(209, 213, 219, 0.3);
//         }

//         .input-container {
//           display: flex;
//           align-items: flex-end;
//           gap: 0.75rem;
//         }

//         .input-field {
//           flex: 1;
//           min-height: 50px;
//           max-height: 150px;
//           padding: 0.75rem 1rem;
//           border: 2px solid rgba(209, 213, 219, 0.3);
//           border-radius: 16px;
//           background: rgba(255, 255, 255, 0.9);
//           backdrop-filter: blur(10px);
//           font-family: inherit;
//           font-size: 1rem;
//           resize: none;
//           outline: none;
//           transition: all 0.2s ease;
//         }

//         .input-field:focus {
//           border-color: #667eea;
//           box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
//         }

//         .input-field:disabled {
//           opacity: 0.6;
//           cursor: not-allowed;
//         }

//         .action-button {
//           width: 50px;
//           height: 50px;
//           border: none;
//           border-radius: 50%;
//           color: white;
//           cursor: pointer;
//           transition: all 0.2s ease;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           flex-shrink: 0;
//         }

//         .send-button {
//           background: linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%);
//           box-shadow: 0 8px 20px rgba(254, 107, 139, 0.3);
//         }

//         .send-button:hover:not(:disabled) {
//           transform: scale(1.05);
//           box-shadow: 0 12px 30px rgba(254, 107, 139, 0.4);
//         }

//         .send-button:disabled {
//           background: rgba(156, 163, 175, 0.5);
//           color: rgba(255, 255, 255, 0.5);
//           cursor: not-allowed;
//           transform: none;
//           box-shadow: none;
//         }

//         .loading-spinner {
//           width: 20px;
//           height: 20px;
//           border: 2px solid rgba(255, 255, 255, 0.3);
//           border-top: 2px solid white;
//           border-radius: 50%;
//           animation: spin 1s linear infinite;
//         }

//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }

//         .input-hint {
//           text-align: center;
//           color: rgba(107, 114, 128, 0.6);
//           font-size: 0.75rem;
//           margin-top: 0.5rem;
//         }

//         /* Mobile responsiveness */
//         @media (max-width: 768px) {
//           .chatbot-container {
//             padding: 1rem 0.5rem;
//           }
          
//           .chat-wrapper {
//             height: calc(100vh - 2rem);
//           }
          
//           .chat-header {
//             padding: 1rem 1.5rem;
//           }
          
//           .message-item {
//             padding: 0 1rem;
//           }
          
//           .input-area {
//             padding: 1rem 1.5rem;
//           }
          
//           .message-content {
//             max-width: 85%;
//           }
//         }
//       `}</style>

//       <div className="chat-wrapper">
//         {/* Header */}
//         <div className="header">
//           <div className="header-chip">
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
//               <path d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.46,13.97L5.82,21L12,17.27Z"/>
//             </svg>
//             AI-Powered Learning Assistant
//           </div>
          
//           <h1 className="main-title">
//             Chat with <span className="gradient-text">SSPACE Bot</span>
//           </h1>
          
//           <p className="subtitle">
//             Get instant answers to your academic questions
//           </p>
//         </div>

//         {/* Chat Container */}
//         <div className="chat-container">
//           {/* Chat Header */}
//           <div className="chat-header">
//             <div className="chat-header-avatar">
//               <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
//                 <path d="M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.9,6 10,5.1 10,4C10,2.9 10.9,2 12,2M21,9V7L15,1H5C3.89,1 3,1.89 3,3V19A2,2 0 0,0 5,21H11V19H5V3H13V9H21Z"/>
//               </svg>
//             </div>
//             <div className="chat-header-info">
//               <h3>SSPACE Bot Assistant</h3>
//               <p>Online • Ready to help</p>
//             </div>
//           </div>

//           {/* Messages Area */}
//           <div className="messages-area">
//             {conversation.map((msg, index) => (
//               <div key={index} className={`message-item ${msg.sender === 'You' ? 'user' : ''}`}>
//                 <div className={`avatar ${msg.sender === 'You' ? 'user-avatar' : 'bot-avatar'}`}>
//                   {msg.sender === 'You' ? (
//                     <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//                       <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
//                     </svg>
//                   ) : (
//                     <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//                       <path d="M20,9V7c0-1.1-0.9-2-2-2h-3c0-1.66-1.34-3-3-3S9,3.34,9,5H6C4.9,5,4,5.9,4,7v2c-1.1,0-2,0.9-2,2v4 c0,1.1,0.9,2,2,2v2c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-2c1.1,0,2-0.9,2-2v-4C22,9.9,21.1,9,20,9z M7.5,11.5 C7.5,10.67,8.17,10,9,10s1.5,0.67,1.5,1.5S9.83,13,9,13S7.5,12.33,7.5,11.5z M16.5,11.5c0,0.83-0.67,1.5-1.5,1.5 s-1.5-0.67-1.5-1.5S14.17,10,15,10S16.5,10.67,16.5,11.5z M8,15h8v2H8V15z"/>
//                     </svg>
//                   )}
//                 </div>
                
//                 <div className="message-content">
//                   <div className={`message-bubble ${msg.sender === 'You' ? 'user-bubble' : 'bot-bubble'}`}>
//                     {msg.text}
//                   </div>
//                   <div className="message-timestamp">
//                     {msg.timestamp}
//                   </div>
//                 </div>
//               </div>
//             ))}
            
//             {loading && <TypingIndicator />}
//             <div ref={messagesEndRef} />
//           </div>

//           {/* Input Area */}
//           <div className="input-area">
//             <div className="input-container">
//               <textarea
//                 className="input-field"
//                 placeholder="Ask me anything about your studies..."
//                 value={userMessage}
//                 onChange={(e) => setUserMessage(e.target.value)}
//                 onKeyPress={handleKeyPress}
//                 disabled={loading}
//                 rows="1"
//               />
              
//               <button
//                 className="action-button send-button"
//                 onClick={handleSend}
//                 disabled={loading || !userMessage.trim()}
//               >
//                 {loading ? (
//                   <div className="loading-spinner" />
//                 ) : (
//                   <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//                     <path d="M2,21L23,12L2,3V10L17,12L2,14V21Z"/>
//                   </svg>
//                 )}
//               </button>
//             </div>
            
//             <div className="input-hint">
//               Press Enter to send, Shift+Enter for new line
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AIChatbot;


import React, { useState, useEffect, useRef, useCallback } from 'react';

const AIChatbot = () => {
  const [userMessage, setUserMessage] = useState('');
  const [conversation, setConversation] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showOptions, setShowOptions] = useState(true);
  const [feedbackStates, setFeedbackStates] = useState({});
  // const [botResponses, setBotResponses] = useState({});
  // const [quickOptions, setQuickOptions] = useState([]);
  const messagesEndRef = useRef(null);
  const hasGreeted = useRef(false);

  // // Load bot responses from file
  // useEffect(() => {
  //   const loadBotData = async () => {
  //     try {
  //       // Try to read from uploaded file first
  //       if (window.fs && window.fs.readFile) {
  //         try {
  //           const fileContent = await window.fs.readFile('bot-responses.txt', { encoding: 'utf8' });
  //           parseBotData(fileContent);
  //           return;
  //         } catch (error) {
  //           console.log('No uploaded file found, using default responses');
  //         }
  //       }
        
  //       // Fallback to default responses
  //       loadDefaultResponses();
  //     } catch (error) {
  //       console.error('Error loading bot data:', error);
  //       loadDefaultResponses();
  //     }
  //   };

  //   loadBotData();
  // }, []);

  // Parse bot data from file content
  // const parseBotData = (content) => {
  //   const lines = content.split('\n');
  //   const responses = {};
  //   const options = [];
  //   let currentSection = '';
  //   let currentResponse = '';

  //   for (let line of lines) {
  //     line = line.trim();
      
  //     if (line.startsWith('#')) {
  //       // Comment line, skip
  //       continue;
  //     } else if (line.startsWith('[') && line.endsWith(']')) {
  //       // Section header like [GREETING] or [QUICK_OPTIONS]
  //       if (currentSection && currentResponse) {
  //         responses[currentSection] = currentResponse.trim();
  //       }
  //       currentSection = line.slice(1, -1).toLowerCase();
  //       currentResponse = '';
  //     } else if (line.startsWith('OPTION:')) {
  //       // Quick option like OPTION: 📚 Study Materials
  //       const optionText = line.substring(7).trim();
  //       const [icon, ...textParts] = optionText.split(' ');
  //       options.push({
  //         icon: icon,
  //         text: textParts.join(' ')
  //       });
  //     } else if (line.startsWith('KEYWORDS:')) {
  //       // Keywords for matching (we'll store this for the current section)
  //       const keywords = line.substring(9).trim().split(',').map(k => k.trim().toLowerCase());
  //       if (currentSection) {
  //         responses[currentSection + '_keywords'] = keywords;
  //       }
  //     } else if (line) {
  //       // Response content
  //       currentResponse += line + '\n';
  //     }
  //   }

  //   // Add the last section
  //   if (currentSection && currentResponse) {
  //     responses[currentSection] = currentResponse.trim();
  //   }

  //   setBotResponses(responses);
  //   if (options.length > 0) {
  //     setQuickOptions(options);
  //   } else {
  //     loadDefaultQuickOptions();
  //   }
  // };

  // // Load default responses if no file is provided
  // const loadDefaultResponses = () => {
  //   const defaultResponses = {
  //     greeting: "👋 Hello! I'm SSPACE Bot, your AI learning assistant. How can I help you with your studies today?",
      
  //     study_materials: "📚 SSPACE Bot offers comprehensive study materials including:\n\n• Interactive video lectures\n• Detailed notes and summaries\n• Practice questions with solutions\n• Mind maps and visual aids\n\nWhich subject would you like to explore?",
  //     study_materials_keywords: ["study", "materials", "notes", "lectures", "resources"],
      
  //     mock_tests: "📝 Our mock test features include:\n\n• Subject-wise practice tests\n• Full-length mock exams\n• Instant results and analysis\n• Performance tracking\n• Time management practice\n\nReady to take a practice test?",
  //     mock_tests_keywords: ["mock", "test", "exam", "practice", "assessment"],
      
  //     exam_preparation: "🎯 SSPACE Bot provides structured exam preparation:\n\n• Personalized study plans\n• Topic-wise coverage tracking\n• Revision schedules\n• Expert tips and strategies\n• Doubt clearing sessions\n\nWhat exam are you preparing for?",
  //     exam_preparation_keywords: ["preparation", "prepare", "exam", "strategy", "plan"],
      
  //     progress_tracking: "📊 Track your learning progress with:\n\n• Detailed performance analytics\n• Subject-wise score trends\n• Time spent studying\n• Strength and weakness analysis\n• Goal setting and achievement\n\nYour progress motivates your success!",
  //     progress_tracking_keywords: ["progress", "track", "analytics", "performance", "score"],
      
  //     greeting_response: "Hello! 👋 I'm here to help you excel in your studies. Whether you need study materials, want to take mock tests, or need guidance with exam preparation, I'm here for you!",
  //     greeting_response_keywords: ["hello", "hi", "hey", "good morning", "good evening"],
      
  //     help: "I'm here to help! 🤝 You can ask me about:\n\n• Study materials and resources\n• Mock tests and practice exams\n• Exam preparation strategies\n• Progress tracking\n• Subject-specific guidance\n\nWhat would you like assistance with?",
  //     help_keywords: ["help", "support", "assist", "guide"],
      
  //     thanks: "You're welcome! 😊 I'm always here to help you succeed in your studies. Keep up the great work!",
  //     thanks_keywords: ["thank", "thanks", "appreciate"],
      
  //     fallback: "That's an interesting question! 🤔 Let me help you with that. As your AI learning assistant, I can provide guidance on study materials, mock tests, exam preparation, and progress tracking. Could you be more specific about what you'd like to know?"
  //   };

  //   setBotResponses(defaultResponses);
  //   loadDefaultQuickOptions();
  // };

  // const loadDefaultQuickOptions = () => {
  //   setQuickOptions([
  //     { icon: '📚', text: "Study Materials" },
  //     { icon: '📝', text: "Mock Tests" },
  //     { icon: '🎯', text: "Exam Preparation" },
  //     { icon: '📊', text: "Progress Tracking" }
  //   ]);
  // };

  // Scroll to the bottom when new messages are added
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [conversation, loading]);

  // // Format bot response with proper line breaks
  const formatBotResponse = (response) => {
    return response
      .split('\n')
      .map(line => line.trim())
      .filter(line => line)
      .join('\n\n');
  };

  // // Add message function
  // const addMessage = useCallback((text, sender, id = Date.now()) => {
  //   const timestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  //   const formattedText = sender === 'SSPACE Bot' ? formatBotResponse(text) : text;
  //   setConversation(prev => [...prev, { 
  //     text: formattedText, 
  //     sender, 
  //     id, 
  //     timestamp 
  //   }]);
  // }, []);
   const addMessage = useCallback((text, sender, id = Date.now()) => {
    const timestamp = new Date().toLocaleTimeString([], { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
    const formattedText = sender === 'SSPACE Bot' ? formatBotResponse(text) : text;
    setConversation(prev => [...prev, { 
      text: formattedText, 
      sender, 
      id, 
      timestamp 
    }]);
  }, []);

  // // Initial greeting
  // useEffect(() => {
  //   if (!hasGreeted.current && botResponses.greeting) {
  //     hasGreeted.current = true;
  //     setTimeout(() => {
  //       addMessage(botResponses.greeting, "SSPACE Bot");
  //     }, 800);
  //   }
  // }, [botResponses.greeting, addMessage]);
  useEffect(() => {
  if (!hasGreeted.current) {
    hasGreeted.current = true;
    setTimeout(() => {
      addMessage(
        "👋 Hello! I'm AceBot, your AI study assistant inside ExamAce.\n\nAsk me anything — concept explanations, exam tips, step-by-step solutions, or quick revision help. I'm here 24/7 to help you ace your exams! 🎯",
        "SSPACE Bot"
      );
    }, 800);
  }
}, [addMessage]);

  // // Handle feedback
  const handleFeedback = async (messageId, isHelpful) => {
    setFeedbackStates(prev => ({
      ...prev,
      [messageId]: isHelpful ? 'helpful' : 'unhelpful'
    }));
  };

  // // Handle quick options
  const handleQuickOption = (option) => {
    addMessage(option.text, "You");
    handleBotResponse(option.text);
  };

  // // Find best response based on keywords
  // const findBestResponse = (userMessage) => {
  //   const msg = userMessage.trim().toLowerCase();
  //   let bestMatch = 'fallback';
  //   let maxMatches = 0;

  //   // Check each response category for keyword matches
  //   Object.keys(botResponses).forEach(key => {
  //     if (key.endsWith('_keywords')) {
  //       const categoryKey = key.replace('_keywords', '');
  //       const keywords = botResponses[key];
  //   // Check each response category for keyword matches
  //   Object.keys(botResponses).forEach(key => {
  //     if (key.endsWith('_keywords')) {
  //       const categoryKey = key.replace('_keywords', '');
  //       const keywords = botResponses[key];
        
  //       if (keywords && Array.isArray(keywords)) {
  //         const matches = keywords.filter(keyword => msg.includes(keyword)).length;
  //         if (matches > maxMatches) {
  //           maxMatches = matches;
  //           bestMatch = categoryKey;
  //         }
  //       }
  //     }
  //   });
  //       if (keywords && Array.isArray(keywords)) {
  //         const matches = keywords.filter(keyword => msg.includes(keyword)).length;
  //         if (matches > maxMatches) {
  //           maxMatches = matches;
  //           bestMatch = categoryKey;
  //         }
  //       }
  //     }
  //   });

  //   return botResponses[bestMatch] || botResponses.fallback || "I'm here to help with your studies!";
  // };
  //   return botResponses[bestMatch] || botResponses.fallback || "I'm here to help with your studies!";
  // };

  // // Enhanced bot response logic
  // const handleBotResponse = async (userMessage) => {
  //   setLoading(true);
  //   setShowOptions(false);

  //   setTimeout(() => {
  //     const response = findBestResponse(userMessage);
      
  //     // Convert markdown-style links to HTML (if any)
  //     const formattedResponse = response
  //       .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer" style="color: #667eea; text-decoration: none; font-weight: 500;">$1</a>');

  //     addMessage(formattedResponse, "SSPACE Bot");
  //     setLoading(false);
  //   }, 1200);
  // };
// replaced 
const handleBotResponse = async (userMessage) => {
  setLoading(true);
  setShowOptions(false);

  try {
    const response = await fetch('https://exam-ace-backend.onrender.com/api/chatbot', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: userMessage,
        userId: 'student_001', // later you can replace this with the logged-in user's ID
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Server error');
    }

    addMessage(data.reply, 'SSPACE Bot');

  } catch (error) {
    console.error('Chatbot error:', error);
    addMessage('⚠️ Something went wrong. Please check your connection and try again.', 'SSPACE Bot');
  } finally {
    setLoading(false);
  }
};



  const handleSend = () => {
    if (!userMessage.trim() || loading) return;
    
    addMessage(userMessage, "You");
    const currentMessage = userMessage;
    setUserMessage('');
    handleBotResponse(currentMessage);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const FeedbackButton = ({ onClick, active, type, disabled }) => (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        border: "none",
        background: "transparent",
        cursor: disabled ? "default" : "pointer",
        marginLeft: type === "up" ? 0 : 8,
        color: active === "helpful" ? "#22c55e" : 
               active === "unhelpful" ? "#ef4444" : "#9ca3af",
        fontSize: "1.1rem",
        opacity: disabled ? 0.4 : 1,
        transition: "color 0.2s, transform 0.2s",
        transform: active ? "scale(1.1)" : "scale(1)",
        padding: "4px"
      }}
      aria-label={type === "up" ? "Helpful" : "Not helpful"}
    >
      {type === "up" ? "👍" : "👎"}
    </button>
  );

  const TypingIndicator = () => (
    <div className="typing-indicator">
      <div className="avatar bot-avatar">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20,9V7c0-1.1-0.9-2-2-2h-3c0-1.66-1.34-3-3-3S9,3.34,9,5H6C4.9,5,4,5.9,4,7v2c-1.1,0-2,0.9-2,2v4 c0,1.1,0.9,2,2,2v2c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-2c1.1,0,2-0.9,2-2v-4C22,9.9,21.1,9,20,9z M7.5,11.5 C7.5,10.67,8.17,10,9,10s1.5,0.67,1.5,1.5S9.83,13,9,13S7.5,12.33,7.5,11.5z M16.5,11.5c0,0.83-0.67,1.5-1.5,1.5 s-1.5-0.67-1.5-1.5S14.17,10,15,10S16.5,10.67,16.5,11.5z M8,15h8v2H8V15z"/>
        </svg>
      </div>
      <div className="typing-bubble">
        <div className="typing-dots">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="chatbot-container">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        .chatbot-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          position: relative;
          overflow: hidden;
          padding: 2rem 1rem;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .chatbot-container::before {
          content: '';
          position: absolute;
          top: 15%;
          left: 8%;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          animation: float 3s ease-in-out infinite;
        }

        .chatbot-container::after {
          content: '';
          position: absolute;
          top: 60%;
          right: 15%;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.05);
          animation: float 4s ease-in-out infinite;
          animation-delay: 1s;
        }

        .file-info {
          position: fixed;
          top: 20px;
          right: 20px;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          padding: 8px 16px;
          border-radius: 20px;
          color: white;
          font-size: 0.8rem;
          z-index: 1000;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }

        @keyframes messageSlide {
          from { opacity: 0; transform: translateX(-20px); }
          to { opacity: 1; transform: translateX(0); }
        }

        @keyframes botMessageSlide {
          from { opacity: 0; transform: translateX(20px); }
          to { opacity: 1; transform: translateX(0); }
        }

        @keyframes typing {
          0%, 60%, 100% { transform: translateY(0); }
          30% { transform: translateY(-5px); }
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .chat-wrapper {
          max-width: 800px;
          margin: 0 auto;
          height: 100vh;
          display: flex;
          flex-direction: column;
          position: relative;
          z-index: 1;
        }

        .header {
          text-align: center;
          margin-bottom: 2rem;
        }

        .header-chip {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(255, 255, 255, 0.15);
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 500;
          margin-bottom: 1rem;
          backdrop-filter: blur(10px);
        }

        .header-chip svg {
          width: 16px;
          height: 16px;
        }

        .main-title {
          font-size: clamp(2rem, 5vw, 3rem);
          font-weight: 900;
          color: white;
          margin-bottom: 0.5rem;
          text-shadow: 0 4px 20px rgba(0,0,0,0.3);
        }

        .gradient-text {
          background: linear-gradient(45deg, #FFD700, #FF6B6B, #4ECDC4);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .subtitle {
          color: rgba(255, 255, 255, 0.9);
          font-weight: 300;
          font-size: 1.1rem;
        }

        .chat-container {
          flex: 1;
          display: flex;
          flex-direction: column;
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 20px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          overflow: hidden;
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
        }

        .chat-header {
          padding: 1.5rem 2rem;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .chat-header-avatar {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .chat-header-info h3 {
          margin: 0;
          font-weight: 600;
          font-size: 1.2rem;
        }

        .chat-header-info p {
          margin: 0;
          opacity: 0.8;
          font-size: 0.9rem;
        }

        .messages-area {
          flex: 1;
          overflow-y: auto;
          padding: 1rem 0;
          background: linear-gradient(to bottom, rgba(248, 250, 252, 0.5), rgba(241, 245, 249, 0.3));
        }

        .messages-area::-webkit-scrollbar {
          width: 6px;
        }

        .messages-area::-webkit-scrollbar-track {
          background: transparent;
        }

        .messages-area::-webkit-scrollbar-thumb {
          background: rgba(148, 163, 184, 0.5);
          border-radius: 10px;
        }

        .message-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 1.5rem;
          padding: 0 2rem;
          animation: messageSlide 0.3s ease-out;
        }

        .message-item.user {
          flex-direction: row-reverse;
          animation: botMessageSlide 0.3s ease-out;
        }

        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          flex-shrink: 0;
        }

        .bot-avatar {
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
          margin-right: 1rem;
        }

        .user-avatar {
          background: linear-gradient(45deg, #4ECDC4 30%, #44A08D 90%);
          box-shadow: 0 4px 12px rgba(78, 205, 196, 0.3);
          margin-left: 1rem;
        }

        .message-content {
          max-width: 75%;
          display: flex;
          flex-direction: column;
        }

        .user .message-content {
          align-items: flex-end;
        }

        .message-bubble {
          padding: 1rem 1.5rem;
          border-radius: 20px;
          word-wrap: break-word;
          line-height: 1.5;
          backdrop-filter: blur(10px);
          margin-bottom: 0.25rem;
          white-space: pre-line;
          animation: fadeInUp 0.3s ease;
        }

        .user-bubble {
          background: linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%);
          color: white;
          box-shadow: 0 8px 20px rgba(254, 107, 139, 0.3);
          font-weight: 500;
        }

        .bot-bubble {
          background: rgba(255, 255, 255, 0.9);
          color: #374151;
          border: 1px solid rgba(209, 213, 219, 0.5);
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        }

        .message-timestamp {
          font-size: 0.75rem;
          color: rgba(107, 114, 128, 0.7);
          margin-top: 0.25rem;
        }

        .feedback-buttons {
          display: flex;
          gap: 4px;
          margin-top: 8px;
          margin-left: 4px;
        }

        .typing-indicator {
          display: flex;
          align-items: flex-start;
          margin-bottom: 1rem;
          padding: 0 2rem;
        }

        .typing-bubble {
          padding: 1rem 1.5rem;
          border-radius: 20px;
          background: rgba(229, 231, 235, 0.8);
          backdrop-filter: blur(10px);
          margin-left: 1rem;
        }

        .typing-dots {
          display: flex;
          gap: 0.25rem;
        }

        .dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #9ca3af;
          animation: typing 1.4s ease-in-out infinite;
        }

        .dot:nth-child(2) { animation-delay: 0.2s; }
        .dot:nth-child(3) { animation-delay: 0.4s; }

        .quick-options {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 8px;
          padding: 12px 16px;
          background: rgba(255, 255, 255, 0.8);
          border-top: 1px solid rgba(209, 213, 219, 0.3);
        }

        .quick-option {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 12px;
          background: rgba(255, 255, 255, 0.9);
          border: 1px solid rgba(209, 213, 219, 0.3);
          border-radius: 12px;
          cursor: pointer;
          color: #374151;
          font-size: 0.9rem;
          transition: all 0.2s ease;
          backdrop-filter: blur(10px);
        }

        .quick-option:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          background: rgba(255, 255, 255, 1);
        }

        .input-area {
          padding: 1.5rem 2rem;
          background: rgba(255, 255, 255, 0.8);
          backdrop-filter: blur(10px);
          border-top: 1px solid rgba(209, 213, 219, 0.3);
        }

        .input-container {
          display: flex;
          align-items: flex-end;
          gap: 0.75rem;
        }

        .input-field {
          flex: 1;
          min-height: 50px;
          max-height: 150px;
          padding: 0.75rem 1rem;
          border: 2px solid rgba(209, 213, 219, 0.3);
          border-radius: 16px;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          font-family: inherit;
          font-size: 1rem;
          resize: none;
          outline: none;
          transition: all 0.2s ease;
        }

        .input-field:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }

        .input-field:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .action-button {
          width: 50px;
          height: 50px;
          border: none;
          border-radius: 50%;
          color: white;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .send-button {
          background: linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%);
          box-shadow: 0 8px 20px rgba(254, 107, 139, 0.3);
        }

        .send-button:hover:not(:disabled) {
          transform: scale(1.05);
          box-shadow: 0 12px 30px rgba(254, 107, 139, 0.4);
        }

        .send-button:disabled {
          background: rgba(156, 163, 175, 0.5);
          color: rgba(255, 255, 255, 0.5);
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }

        .loading-spinner {
          width: 20px;
          height: 20px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top: 2px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .input-hint {
          text-align: center;
          color: rgba(107, 114, 128, 0.6);
          font-size: 0.75rem;
          margin-top: 0.5rem;
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .chatbot-container {
            padding: 1rem 0.5rem;
          }
          
          .chat-wrapper {
            height: calc(100vh - 2rem);
          }
          
          .chat-header {
            padding: 1rem 1.5rem;
          }
          
          .message-item {
            padding: 0 1rem;
          }
          
          .input-area {
            padding: 1rem 1.5rem;
          }
          
          .message-content {
            max-width: 85%;
          }

          .quick-options {
            padding: 12px;
          }

          .file-info {
            display: none;
          }
        }
      `}</style>

      {/* File status indicator */}
      {/* <div className="file-info">
        {Object.keys(botResponses).length > 0 ? '📄 Bot responses loaded' : '⏳ Loading...'}
      </div> */}

      <div className="chat-wrapper">
        {/* Header */}
        <div className="header">
          <div className="header-chip">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.46,13.97L5.82,21L12,17.27Z"/>
            </svg>
            AI-Powered Learning Assistant
          </div>
          
          <h1 className="main-title">
            Chat with <span className="gradient-text">SSPACE Bot</span>
          </h1>
          
          <p className="subtitle">
            Get instant answers to your academic questions
          </p>
        </div>

        {/* Chat Container */}
        <div className="chat-container">
          {/* Chat Header */}
          <div className="chat-header">
            <div className="chat-header-avatar">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12,2C13.1,2 14,2.9 14,2.9 14,4C14,5.1 13.1,6 12,6C10.9,6 10,5.1 10,4C10,2.9 10.9,2 12,2M21,9V7L15,1H5C3.89,1 3,1.89 3,3V19A2,2 0 0,0 5,21H11V19H5V3H13V9H21Z"/>
              </svg>
            </div>
            <div className="chat-header-info">
              <h3>SSPACE Bot Assistant</h3>
              <p>Online • Ready to help</p>
            </div>
          </div>

          {/* Messages Area */}
          <div className="messages-area">
            {conversation.map((msg, index) => (
              <div key={msg.id} className={`message-item ${msg.sender === 'You' ? 'user' : ''}`}>
                <div className={`avatar ${msg.sender === 'You' ? 'user-avatar' : 'bot-avatar'}`}>
                  {msg.sender === 'You' ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20,9V7c0-1.1-0.9-2-2-2h-3c0-1.66-1.34-3-3-3S9,3.34,9,5H6C4.9,5,4,5.9,4,7v2c-1.1,0-2,0.9-2,2v4 c0,1.1,0.9,2,2,2v2c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-2c1.1,0,2-0.9,2-2v-4C22,9.9,21.1,9,20,9z M7.5,11.5 C7.5,10.67,8.17,10,9,10s1.5,0.67,1.5,1.5S9.83,13,9,13S7.5,12.33,7.5,11.5z M16.5,11.5c0,0.83-0.67,1.5-1.5,1.5 s-1.5-0.67-1.5-1.5S14.17,10,15,10S16.5,10.67,16.5,11.5z M8,15h8v2H8V15z"/>
                    </svg>
                  )}
                </div>
                
                <div className="message-content">
                  <div 
                    className={`message-bubble ${msg.sender === 'You' ? 'user-bubble' : 'bot-bubble'}`}
                    dangerouslySetInnerHTML={{ __html: msg.text }}
                  />
                  <div className="message-timestamp">
                    {msg.timestamp}
                  </div>
                  
                  {/* Feedback buttons for bot messages */}
                  {msg.sender === "SSPACE Bot" && (
                    <div className="feedback-buttons">
                      <FeedbackButton
                        type="up"
                        onClick={() => handleFeedback(msg.id, true)}
                        active={feedbackStates[msg.id]}
                        disabled={!!feedbackStates[msg.id]}
                      />
                      <FeedbackButton
                        type="down"
                        onClick={() => handleFeedback(msg.id, false)}
                        active={feedbackStates[msg.id]}
                        disabled={!!feedbackStates[msg.id]}
                      />
                    </div>
                  )}
                </div>
              </div>
            ))}
            
            {loading && <TypingIndicator />}
            <div ref={messagesEndRef} />
          </div>

          {/* Quick Options */}
          {showOptions && (
  <div className="quick-options">
    {[
      { icon: '📚', text: 'Study Materials' },
      { icon: '📝', text: 'Mock Tests' },
      { icon: '🎯', text: 'Exam Preparation' },
      { icon: '📊', text: 'Progress Tracking' },
    ].map((option, index) => (
      <div
        key={index}
        className="quick-option"
        onClick={() => handleQuickOption(option)}
      >
        <span style={{ fontSize: '1rem' }}>{option.icon}</span>
        <span>{option.text}</span>
      </div>
    ))}
  </div>
)}
         
          



          {/* Input Area */}
          <div className="input-area">
            <div className="input-container">
              <textarea
                className="input-field"
                placeholder="Ask me anything about your studies..."
                value={userMessage}
                onChange={(e) => setUserMessage(e.target.value)}
                onKeyPress={handleKeyPress}
                disabled={loading}
                rows="1"
              />
              
              <button
                className="action-button send-button"
                onClick={handleSend}
                disabled={loading || !userMessage.trim()}
              >
                {loading ? (
                  <div className="loading-spinner" />
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M2,21L23,12L2,3V10L17,12L2,14V21Z"/>
                  </svg>
                )}
              </button>
            </div>
            
            <div className="input-hint">
              Press Enter to send, Shift+Enter for new line
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIChatbot;
